import React, { useState } from 'react'
import centrosCustoRepository from './CentrosCustoRepository'
import Autocomplete from '../../components/Autocomplete'

export const loadCentrosCusto = async inputValue => {
  const response = await centrosCustoRepository.list({
    query: {
      descricao: inputValue,
      ativo: true,
      order: 'descricao asc'
    },
    paginate: {
      limit: 10
    }
  })
  if (response.ok) {
    const options = response.data.map(centroCusto => {
      const label = `${centroCusto.descricao} (${centroCusto.empresa?.sigla})`
      return { id: centroCusto.id, value: centroCusto.id, label }
    })
    return options
  }
  return []
}

const labelFormat = data => {
  if (!Array.isArray(data) && data) {
    const label = `${data.descricao} (${data.empresa?.sigla})`
    return {
      id: data.id,
      value: data.id,
      label
    }
  }
}

const CentroCustoAutocomplete = props => {
  const [inputFocused, setInputFocused] = useState(false);

  const handleFocus = () => {
    if (!inputFocused) setInputFocused(true);
  };

  return (
    <Autocomplete
      {...props}
      repository={centrosCustoRepository}
      labelOption="descricao"
      labelFormat={labelFormat}
      loadOptions={inputFocused ? loadCentrosCusto : async () => []}
      onFocus={handleFocus}
      defaultOptions={false}
    />
  )
}

export default CentroCustoAutocomplete
